import { fork } from 'redux-saga/effects';

import removeMemberSaga from './remove-member-saga';
import inviteToFamilyCircleSaga from './invite-to-family-circle-saga';
import changeRoleSaga from './change-role-saga';

export default function* root() {
  yield fork(inviteToFamilyCircleSaga);
  yield fork(changeRoleSaga);
  yield fork(removeMemberSaga);
}



// WEBPACK FOOTER //
// ./src/redux/circles/sagas/circle-of-care/index.js